export default function checkIsSupporter(entityId, userId, supporterMap) {
  return supporterMap?.get(entityId)?.has(userId);
}
